export type EmailAnalyticsSurface = 'load_hub' | 'box_truck'

export const isLoadHubEmailSurface = (surface: EmailAnalyticsSurface | undefined): boolean => surface === 'load_hub'
